import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import React from 'react'

export const FreeTextExplanation = () => (
  <LocalizedTypography translationKey="search:free-text-explanation">
    Free text search for parts, assemblies, materials and projects
  </LocalizedTypography>
)
